<template>
  <b-container>
    <Breadcrumbs crumbString="What We Do,Commemorative"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>
          enviroSIGNS offers a variety of materials that are well-suited to commemorative and recognition situations.
        </div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-8 col-lg-8">
              <b-row>
                <b-col class="col-12 image-pod">
                  <div class="img commemorative-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/commemorative/commemorative-plaques-novalloy.jpg') + ')'}"></div>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12 image-pod">
                  <div class="img commemorative-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/commemorative/recognition-plaques-CHPL.jpg') + ')'}"></div>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="col-12 col-md-4 col-lg-4 image-pod">
              <div class="img commemorative-249-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/commemorative/recognition-plaque-novalloy.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-6 col-md-6 image-pod">
              <div class="img commemorative-73-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/commemorative/commemorative-plaques-duraReader.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-3 col-md-3 image-pod">
              <div class="img commemorative-150-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/commemorative/recognition-plaque-novalloy-plus.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-3 col-md-3 image-pod">
              <div class="img commemorative-150-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/commemorative/commemorative-sign-CHPL.jpg') + ')'}"></div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'

  export default {
    components: {
      Breadcrumbs
    },

    data () {
      return {
        title: 'Commemorative'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/whatWeDo/Commemorative.vue